import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["size", "intent"];
/* eslint-disable no-use-before-define */import * as React from 'react';
export function Icon(_ref) {
  var size = _ref.size,
    intent = _ref.intent,
    props = _objectWithoutProperties(_ref, _excluded);
  var _sizeMap$size = sizeMap[size],
    width = _sizeMap$size.width,
    height = _sizeMap$size.height;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 ".concat(width, " ").concat(height),
    width: width,
    height: height
  }, props), intentMap[intent][size]);
}
var sizeMap = {
  m: {
    width: 20,
    height: 20
  },
  s: {
    width: 16,
    height: 16
  },
  xs: {
    width: 12,
    height: 12
  },
  xxs: {
    width: 8,
    height: 8
  }
};
var intentMap = {
  add: {
    m: /*#__PURE__*/React.createElement("path", {
      d: "M9.993 1a.75.75 0 0 1 .75.75v7.502h7.51a.75.75 0 0 1 0 1.5h-7.51v7.501a.75.75 0 0 1-1.5 0V1.75a.75.75 0 0 1 .75-.75ZM1 10.002a.75.75 0 0 1 .75-.75h5.825a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75Z"
    }),
    s: /*#__PURE__*/React.createElement("path", {
      d: "M7.993 1a.65.65 0 0 1 .65.65v5.7h5.705a.65.65 0 1 1 0 1.3H8.643v5.698a.65.65 0 0 1-1.3 0V1.65a.65.65 0 0 1 .65-.65ZM1 8a.65.65 0 0 1 .65-.65h4a.65.65 0 1 1 0 1.3h-4A.65.65 0 0 1 1 8Z"
    }),
    xs: /*#__PURE__*/React.createElement("path", {
      d: "M5.996 1a.55.55 0 0 1 .55.55v3.9h3.905a.55.55 0 1 1 0 1.1H6.546v3.9a.55.55 0 0 1-1.1 0v-8.9a.55.55 0 0 1 .55-.55ZM.999 6a.55.55 0 0 1 .55-.55h2.5a.55.55 0 0 1 0 1.1h-2.5A.55.55 0 0 1 1 6Z"
    }),
    xxs: /*#__PURE__*/React.createElement("path", {
      d: "M3.997-.002a.55.55 0 0 1 .55.55V3.45h2.905a.55.55 0 1 1 0 1.1H4.547v2.902a.55.55 0 1 1-1.1 0V.548a.55.55 0 0 1 .55-.55ZM-.003 4a.55.55 0 0 1 .55-.55h1.598a.55.55 0 0 1 0 1.1H.548A.55.55 0 0 1-.002 4Z"
    })
  },
  subtract: {
    m: /*#__PURE__*/React.createElement("path", {
      d: "M1.954 10.002a.75.75 0 0 1 .75-.75h14.633a.75.75 0 0 1 0 1.5H2.704a.75.75 0 0 1-.75-.75Z"
    }),
    s: /*#__PURE__*/React.createElement("path", {
      d: "M2.092 8a.65.65 0 0 1 .65-.65h10.516a.65.65 0 0 1 0 1.3H2.742a.65.65 0 0 1-.65-.65Z"
    }),
    xs: /*#__PURE__*/React.createElement("path", {
      d: "M1 6a.6.6 0 0 1 .6-.6h8.8a.6.6 0 1 1 0 1.2H1.6A.6.6 0 0 1 1 6Z"
    }),
    xxs: /*#__PURE__*/React.createElement("path", {
      d: "M0 4a.5.5 0 0 1 .5-.5h6.997a.5.5 0 1 1 0 1H.5A.5.5 0 0 1 0 4Z"
    })
  },
  remove: {
    m: /*#__PURE__*/React.createElement("path", {
      d: "M2.255 2.255a.7.7 0 0 1 .99 0l5.166 5.166a.7.7 0 0 1-.99.99L2.255 3.245a.7.7 0 0 1 0-.99Zm15.491 0a.7.7 0 0 1 0 .99l-6.755 6.756 6.755 6.755a.7.7 0 1 1-.99.99l-6.755-6.755-6.756 6.755a.7.7 0 1 1-.99-.99L9.502 9.51l.004-.003.003-.004 7.247-7.247a.7.7 0 0 1 .99 0Z"
    }),
    s: /*#__PURE__*/React.createElement("path", {
      d: "M2.226 2.226a.6.6 0 0 1 .848 0l3.69 3.69a.6.6 0 0 1-.848.848l-3.69-3.69a.6.6 0 0 1 0-.848Zm11.546 0a.6.6 0 0 1 0 .848L8.847 8l4.925 4.924a.6.6 0 1 1-.849.849L8 8.847l-4.925 4.925a.6.6 0 0 1-.848-.849L12.923 2.226a.6.6 0 0 1 .849 0Z"
    }),
    xs: /*#__PURE__*/React.createElement("path", {
      d: "M10.792 1.211a.55.55 0 0 1 0 .778L6.779 6l4.012 4.013a.55.55 0 1 1-.777.778L6 6.779l-4.01 4.013a.55.55 0 1 1-.778-.778l4.397-4.397a.961.961 0 0 1 .009-.01l4.397-4.396a.55.55 0 0 1 .778 0Zm-9.58 0a.55.55 0 0 1 .777 0L4.77 3.993a.55.55 0 1 1-.778.778L1.211 1.989a.55.55 0 0 1 0-.778Z"
    }),
    xxs: /*#__PURE__*/React.createElement("path", {
      d: "M7.839.161a.55.55 0 0 1 0 .778L4.776 4.002l3.063 3.063a.55.55 0 1 1-.778.778L3.998 4.78.935 7.843a.55.55 0 1 1-.778-.778L7.061.161a.55.55 0 0 1 .778 0Zm-7.682 0a.55.55 0 0 1 .778 0l1.903 1.903a.55.55 0 1 1-.777.778L.157.94a.55.55 0 0 1 0-.778Z"
    })
  },
  expand: {
    m: /*#__PURE__*/React.createElement("path", {
      d: "M1.228 6.21a.75.75 0 0 1 1.06.016l7.714 7.947 7.713-7.947a.75.75 0 1 1 1.076 1.044l-8.251 8.502a.75.75 0 0 1-1.077 0L1.212 7.27a.75.75 0 0 1 .016-1.06Z"
    }),
    s: /*#__PURE__*/React.createElement("path", {
      d: "M1.202 5.186a.654.654 0 0 1 .933.019L8 11.37l5.865-6.166a.654.654 0 0 1 .933-.019c.262.256.27.678.018.943l-6.34 6.667a.656.656 0 0 1-.951 0l-6.34-6.667a.672.672 0 0 1 .017-.943Z"
    }),
    xs: /*#__PURE__*/React.createElement("path", {
      d: "M1.195 4.157a.6.6 0 0 1 .847.036l3.96 4.32 3.96-4.32a.6.6 0 0 1 .885.811L6.444 9.806a.6.6 0 0 1-.884 0L1.158 5.004a.6.6 0 0 1 .037-.847Z"
    }),
    xxs: /*#__PURE__*/React.createElement("path", {
      d: "M.186 2.143a.554.554 0 0 1 .786.044L4 5.597l3.028-3.41a.554.554 0 0 1 .786-.044c.23.207.25.562.044.793L4.415 6.813a.555.555 0 0 1-.83 0L.142 2.936a.564.564 0 0 1 .044-.793Z"
    })
  },
  collapse: {
    m: /*#__PURE__*/React.createElement("path", {
      d: "M18.776 13.788a.75.75 0 0 1-1.06-.016l-7.714-7.947-7.714 7.947a.75.75 0 0 1-1.076-1.044l8.251-8.502a.75.75 0 0 1 1.077 0l8.252 8.502a.75.75 0 0 1-.016 1.06Z"
    }),
    s: /*#__PURE__*/React.createElement("path", {
      d: "M14.798 10.814a.654.654 0 0 1-.933-.018L8 4.629l-5.865 6.167a.654.654 0 0 1-.933.018.672.672 0 0 1-.018-.943l6.34-6.666a.656.656 0 0 1 .951 0l6.34 6.666a.672.672 0 0 1-.017.943Z"
    }),
    xs: /*#__PURE__*/React.createElement("path", {
      d: "M10.81 7.842a.6.6 0 0 1-.848-.037l-3.96-4.318-3.96 4.318a.6.6 0 1 1-.884-.81L5.56 2.193a.6.6 0 0 1 .884 0l4.403 4.802a.6.6 0 0 1-.037.847Z"
    }),
    xxs: /*#__PURE__*/React.createElement("path", {
      d: "M7.814 5.857a.554.554 0 0 1-.786-.044L4 2.403.972 5.813a.554.554 0 0 1-.786.044.564.564 0 0 1-.044-.793l3.443-3.877a.555.555 0 0 1 .83 0l3.443 3.877a.564.564 0 0 1-.044.793Z"
    })
  }
};